import { useQuery } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { ITemporaryProFormaUrl } from '../../views/ProFormaUpload/types';

interface IParams {
    organizationUuid: string;
    dealId: number;
    filePath: string;
}

const getUploadUrl = async ({ organizationUuid, dealId, filePath }: IParams): Promise<ITemporaryProFormaUrl> => {
    const response = await axiosInstance.get(`${API_ENDPOINTS.UPLOADED_PRO_FORMA.PREVIEW(organizationUuid, dealId)}?&filePath=${filePath}`);
    return response.data;
};

const useGetTemporaryProFormaUrl = (organizationUuid: string, dealId: number, filePath: string, options?: any) => useQuery<ITemporaryProFormaUrl>({
    queryKey: ['TemporaryProFormaUrl', organizationUuid, dealId, filePath],
    queryFn: () => getUploadUrl({ organizationUuid, dealId, filePath }),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    staleTime: Infinity,
    cacheTime: Infinity,
    ...options,
});

export default useGetTemporaryProFormaUrl;
